import React, { useEffect, useState, useCallback } from "react";
import Switch from "@mui/material/Switch";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import checkcircleImage from "../../assests/images/check-circle.png";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import starImages from "../../assests/images/star.png";
import evaluationImages from "../../assests/images/evaluation.png";
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import Rating from '@mui/material/Rating';
import Tooltip from '@mui/material/Tooltip';
import { vendorServices } from "../../services/vendorEvaluationServices";
import _ from "lodash";
import Stack from "@mui/material/Stack";
import { useParams } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import PaginationItem from "@mui/material/PaginationItem";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AlertComponent from "../alert/alert";
import { UserObj } from "../../services/localStarage";
import axios from "axios";
import { urlConstants } from "../../constant";
import { Backdrop, CircularProgress } from "@mui/material";
import Button from '@mui/material/Button';


const style1 = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const stylevendor = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "30%",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const initialColumns = [
  { id: "col1", label: "Event ID" },
  { id: "col2", label: "Event Creation Date" },
  { id: "col3", label: "Event created By" },
  { id: "col4", label: "Number of Vendors" },
  { id: "col5", label: "Departments" },
  { id: "col6", label: "Rating" },
  { id: "col7", label: "Status" },
  { id: "col8", label: "Progress" },
];

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));
function EvaluationPerfomonaceRatting() {

  const [openrealloactionmodal, setOpenRealloactionModal] = useState(false);
  const [openrealloactionsuccess, setOpenRealloactionSuccess] = useState(false);
  const [openratingperfomanceevaluation, setOpenRatingPerfomancEvaluation] = useState(false);
  const [perdomanceratingevaluation, setPerdomanceratingevaluation] = useState('');
  const [openratingperfomancesuccess, setOpenRatingPerfomancSuccess] = useState(false);
  const [openfinalratingmodal, setOpenFinalRatingModal] = useState(false);
  const [columns, setColumns] = useState(initialColumns);
  const [vendorRatingRole, setVendorRatingRole] = useState('');
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [workDone, setWorkDone] = useState('Yes');
  const [feedback, setFeedback] = useState('');
  const [reviewForm, setReviewForm] = useState({});
  const [vendorEvaluationlist, setVendorEvaluationlist] = useState();
  const requestPayloadInitials = {
    pageNumber: 1,
    pageSize: 10,
    sortArray: [],
    searchCriteria: [],
  };
  const [requestPayload, setRequestPayload] = useState(requestPayloadInitials);
  const [filterText, setFilterText] = useState("");
  const [filterFormData, setFilterFormData] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [vendorRatingID, setvendorRatingID] = useState(false);
  const [email, setEmail] = useState('');
  const [selectedVendorIDs, setSelectedVendorIDs] = useState([]);
  const [isSelectAll, setIsSelectAll] = useState(false);
  const [alertComponent, setAlertComponent] = useState({ open: false, message: "", type: "", });
  const [vendorFinalRating, setVendorFinalRating] = useState('');
  const [vendorFinalRatingDepartKey, setVendorFinalRatingDepartKey] = useState('');
  const [vendorFilterData, setvendorFilterData] = useState({});
  const [isForMeChecked, setIsForMeChecked] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const reorderedColumns = Array.from(columns);
    const [removed] = reorderedColumns.splice(result.source.index, 1);
    reorderedColumns.splice(result.destination.index, 0, removed);
    setColumns(reorderedColumns);
  };

  const [selectedPackage, setSelectedPackage] = useState('');
  const [selectedProject, setSelectedProject] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('');

  const [checked, setChecked] = React.useState(true);

  useEffect(() => {
    setChecked(false);
    getFilterlist();
  }, []);

  // const handleChange = (event) => {
  //   setChecked(event.target.checked);
  // };
  const handleClose = (event, reason) => {
    setAlertComponent({ ...alertComponent, open: false });
  };

  const StyledRating = styled(Rating)({
    '& .MuiRating-iconFilled': {
      color: '#ff6d75',
    },
    '& .MuiRating-iconHover': {
      color: '#ff3d47',
    },
  });
  // sadfasdf = [
  //   {
  //     blockName: "engineerinfg",
  //     name: "Enginner",
  //     reviewForm: [engineeringCapability: 'Engineering Capability',
  //       responsiveness: 'Responsiveness',
  //       drawingCompleteness: 'Drawing Completeness',
  //       testingFacility: 'Testing Facility',
  //       manufacturingQuality: 'Manufacturing Quality',
  //     ], dfasdf
  //   },
  //   {
  //     blockName: "billdesk",
  //     name: "BILL_DESK",
  //     reviewForm: [
  //       { "keyName": "engineeringCapability", value: 0 },
  //       { "keyName": "any", value: 0 },
  //       { "keyName": "engineeringCapability", value: 0 },
  //       { "keyName": "engineeringCapability", value: 0 },
  //       engineeringCapability: 'Engineering Capability',
  //       responsiveness: 'Responsiveness',
  //       drawingCompleteness: 'Drawing Completeness',
  //       testingFacility: 'Testing Facility',
  //       manufacturingQuality: 'Manufacturing Quality',
  //     ],
  //   }
  // ]
  const departmentCriteria = {
    engineering: {
      engineeringCapability: 'Engineering Capability',
      responsiveness: 'Responsiveness',
      drawingCompleteness: 'Drawing Completeness',
      testingFacility: 'Testing Facility',
      manufacturingQuality: 'Manufacturing Quality',
    },
    billDesk: {
      invoiceCompleteness: 'Invoice Completeness',
      necessaryDocuments: 'Necessary Documents',
    },
    store: {
      packingListCompleteness: 'Packing List Completeness',
      packingQuality: 'Packing Quality',
      stacking: 'Stacking',
      accessForUnloading: 'Access for Unloading',
    },
    pmo: {
      capability: 'Capability',
      resourceMobilisation: 'Resource Mobilisation',
      quality: 'Quality',
      delivery: 'Delivery',
      workExecution: 'Work Execution',
    },
    procurement: {
      financialCapability: 'Financial Capability',
      pastExperience: 'Past Experience',
      ongoingProjects: 'Ongoing Projects',
      equipmentResources: 'Equipment Resources',
    },
    ehs: {
      maintainance: 'maintainance',
      useofPpe: 'Use of PPE',
      compliance: 'Compliance',
    },
    projects: {
      capability: 'Capability',
      resourceMobilisation: 'Resource Mobilisation',
      quality: 'Quality',
      delivery: 'Delivery',
      workExecution: 'Work Execution',
    },
    quality: {
      compliances: 'Compliances',
      cooperationAspects: 'Cooperation Aspects',
      overallWorkmanship: 'Overall Workmanship',
    },
  };

  const handleRatingChange = (criteria, value) => {
    setReviewForm(prevState => ({ ...prevState, [criteria]: value }));
  };

  const vendorTabChange = (e) => {
    const workDoneValue = parseInt(e.target.value, 10);;
    if (workDoneValue === 2) {
      setReviewForm({});
    }
    setPerdomanceratingevaluation(workDoneValue);
  };
  const openAlert = (open, type, message) => {
    setAlertComponent({ open, type, message });
  };
  const handleSubmit = () => {
    const workDoneSelectValue = document.getElementById('venodr_workDone').value;

    if (workDoneSelectValue === "") {
      openAlert(true, "error", "Please select an option for Work Done.");
      return;
    }
    if (perdomanceratingevaluation === 1) {
      const criteriaKeys = Object.keys(departmentCriteria[vendorRatingRole]);
      const isFormIncomplete = criteriaKeys.some(criteria => !reviewForm[criteria] && reviewForm[criteria] !== 0);
      if (isFormIncomplete) {
        openAlert(true, "error", "Please input rating for all criteria.");
        return;
      }
    }

    const finalRating = Object.values(reviewForm).reduce((a, b) => a + b, 0) / Object.keys(reviewForm).length;
    const workDone = (perdomanceratingevaluation === 1) ? "Yes" : "No";
    const formData = {
      workDone: workDone,
      finalRating: finalRating.toFixed(2),
      feedback: feedback,
      reviewForm: reviewForm,
      vendorEvaluationId: vendorRatingID,
      departmentKey: vendorRatingRole
    };
    vendorServices
      .submitVendorRating(formData)
      .then((res) => {
        if (res.data.success === true) {
          // setVendorEvaluationlist(res?.data?.data);
          setOpenRatingPerfomancSuccess(true);
          setOpenRatingPerfomancEvaluation(false);
          getVendorEvaluationlist(requestPayload, filterText, selectedPackage, selectedProject, selectedCategory, isForMeChecked);
          setFeedback('');
          setReviewForm({});
          setPerdomanceratingevaluation('');
          setTimeout(function () {
            // window.location.reload(1);
          }, 2000);
          // openAlert(true, "success", `${res?.data?.message}`);
        } else {
          openAlert(false, "error", `${res?.data?.message}`);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message} `);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };



  const { id } = useParams();

  const getVendorEvaluationlist = (requestPayloadParam, filterTextParam, packageFilter, projectFilter, categoryFilter, checked) => {
    setIsLoading(true);
    let param = `?page=${requestPayloadParam?.pageNumber}&pageSize=${requestPayloadParam?.pageSize}&search=${encodeURIComponent(filterTextParam)}`;
    if (requestPayloadParam.sortArray.length > 0) {
      param += `&sortBy=${requestPayloadParam.sortArray[0]}&sortOrder=${requestPayloadParam.sortArray[1]}`;
    }
    if (packageFilter) {
      param += `&packageName=${packageFilter}`;
    }
    if (projectFilter) {
      param += `&projectName=${projectFilter}`;
    }
    if (categoryFilter) {
      param += `&category=${categoryFilter}`;
    }
    if (checked != true) {
      param += `&selfAssignee=${!checked}`;
    }
    vendorServices
      .getVendorEvaluListing(id, param)
      .then((res) => {
        if (res.data.success === true) {
          setVendorEvaluationlist(res?.data?.data);
        } else {
          setAlertComponent({
            open: true,
            type: "error",
            message: `No Data Found `,
          });
        }
      })
      .catch(function (error) {
        setAlertComponent({
          open: true,
          type: "error",
          message: `${error?.response?.data?.message} `,
        });
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };
  const debouncedSearch = useCallback(
    _.debounce((searchTerm) => {
      let requestPayloadInit = _.cloneDeep(requestPayload);
      requestPayloadInit.pageNumber = 1;
      setRequestPayload(requestPayloadInit);
    }, 800),
    []
  );

  const onFilterTextChange = (e) => {
    let { value } = e.target;
    setFilterText(value);
    debouncedSearch(e.target.value);
  };



  const onKeyPressHandler = (e) => {
    e.persist();
    if (e.key === "Enter") {
      onFilterSubmit();
    }
  };

  const onFilterSubmit = () => {
    // setVendorEvaluationlist(requestPayload, filterText);
    getVendorEvaluationlist(requestPayload, filterText, selectedPackage, selectedProject, selectedCategory, checked);
  };

  const onPageSizeChange = (e) => {
    let { value } = e.target;
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageSize = value;
    requestPayloadInit.pageNumber = 1;
    setRequestPayload(requestPayloadInit);
  }
  const onPaginationChange = (e, value) => {
    let requestPayloadInit = _.cloneDeep(requestPayload);
    requestPayloadInit.pageNumber = value;
    setRequestPayload(requestPayloadInit);
  }


  const showRating = (row) => {
    const vendorID = row?._id;
    setvendorRatingID(vendorID)
    setOpenRatingPerfomancEvaluation(true);
    let department = "buyer";
    const userDepartment = UserObj?.department?.departmentName;
    switch (userDepartment) {
      case "ENGINEERING":
        department = "engineering"
        break;
      case "BILL_DESK":
        department = "billDesk"
        break;
      case "STORE":
        department = "store"
        break;
      case "PMO":
        department = "pmo"
        break;
      case "PROCUREMENT":
        department = "procurement"
        break;
      case "EHS":
        department = "ehs"
        break;
      case "PROJECTS":
        department = "projects"
        break;
      case "QUALITY":
        department = "quality"
        break;
      default:
        department = "buyer";
        break;

    }
    setVendorRatingRole(department);
  }

  const showFinalRating = (row, departKey) => {
    setVendorFinalRating(row);
    setVendorFinalRatingDepartKey(departKey);
    setOpenFinalRatingModal(true);
  }

  const getVendorID = (row) => {
    const vendorID = row?._id;
    setSelectedVendorIDs((prevIDs) => {
      if (prevIDs.includes(vendorID)) {
        return prevIDs.filter((id) => id !== vendorID);
      } else {
        return [...prevIDs, vendorID];
      }
    });
  }


  const handleSelectAll = () => {
    if (isSelectAll) {
      setSelectedVendorIDs([]);
    } else {
      const allVendorIDs = vendorEvaluationlist.vendors.map((vendor) => vendor._id);
      setSelectedVendorIDs(allVendorIDs);
    }
    setIsSelectAll(!isSelectAll);
  };

  const handleIndividualSelect = (row) => {
    const vendorID = row._id;
    setSelectedVendorIDs((prevIDs) => {
      if (prevIDs.includes(vendorID)) {
        return prevIDs.filter((id) => id !== vendorID);
      } else {
        return [...prevIDs, vendorID];
      }
    });
  };
  const handleEmailChange = (event) => {
    setEmail(event.target.value);
  };
  const getDepartmentKey = () => {
    let department = "buyer";
    const userDepartment = UserObj?.department?.departmentName;
    switch (userDepartment) {
      case "ENGINEERING":
        department = "engineering"
        break;
      case "BILL_DESK":
        department = "billDesk"
        break;
      case "STORE":
        department = "store"
        break;
      case "PMO":
        department = "pmo"
        break;
      case "PROCUREMENT":
        department = "procurement"
        break;
      case "EHS":
        department = "ehs"
        break;
      case "PROJECTS":
        department = "projects"
        break;
      case "QUALITY":
        department = "quality"
        break;
      default:
        department = "buyer";
        break;

    }
    return department;
  }
  const handleAllocationSubmit = () => {
    setIsLoading(true);
    const DepartmentKey = getDepartmentKey();
    const formData = {
      email: email,
      departmentKey: DepartmentKey,
      vendorEvaluationIds: selectedVendorIDs,
      evaluationEventId: id, // Event id
    };
    vendorServices
      .submitVendorReallocate(formData)
      .then((res) => {
        if (res.data.success === true) {
          setOpenRealloactionModal(false);
          setOpenRealloactionSuccess(true);
          setTimeout(function () {
            window.location.reload(1);
          }, 2000);
          // openAlert(true, "success", `${res?.data?.message}`);
        } else {
          openAlert(false, "error", `${res?.data?.message}`);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message} `);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  };

  const getFilterlist = () => {
    setIsLoading(true);
    vendorServices
      .getVendorEvaluationFilterlist(id)
      .then((res) => {
        if (res.data.success === true) {
          setvendorFilterData(res?.data?.data);
        } else {
          openAlert(false, "error", `${res?.data?.message}`);
        }
      })
      .catch(function (error) {
        openAlert(true, "error", `${error?.response?.data?.message} `);
      })
      .finally((param) => {
        setIsLoading(false);
      });
  }
  const handlePackageChange = (event) => {
    const newPackage = event.target.value;
    setSelectedPackage(newPackage);
    // getVendorEvaluationlist(requestPayload, filterText, newPackage, selectedProject, selectedCategory, isForMeChecked);
  };
  const handleProjectChange = (event) => {
    const newProject = event.target.value;
    setSelectedProject(newProject);
    // getVendorEvaluationlist(requestPayload, filterText, selectedPackage, newProject, selectedCategory, isForMeChecked);
  };

  const handleCategoryChange = (event) => {
    const newCategory = event.target.value;
    setSelectedCategory(newCategory);
    // getVendorEvaluationlist(requestPayload, filterText, selectedPackage, selectedProject, newCategory, isForMeChecked);
  };

  useEffect(() => {
    const encodedProject = encodeURIComponent(selectedProject);
    const encodedPackage = encodeURIComponent(selectedPackage);
    const encodedCategory = encodeURIComponent(selectedCategory);

    getVendorEvaluationlist(requestPayload, filterText, encodedPackage, encodedProject, encodedCategory, isForMeChecked);
  }, [selectedProject, requestPayload, selectedPackage, selectedCategory, isForMeChecked]);

  // useEffect(() => {
  //   getVendorEvaluationlist(requestPayload, filterText, selectedPackage, selectedProject, selectedCategory, isForMeChecked);
  // }, [requestPayload]);

  const handleForMeToggle = (checked) => {
    setIsForMeChecked(checked);
    getVendorEvaluationlist(requestPayload, filterText, selectedPackage, selectedProject, selectedCategory, checked);
  };
  const DownloadVendorReport = () => {
    setIsLoading(true);
    setIsDownloading(true);
    if (id) {
      axios({
        method: 'POST',
        url: `${urlConstants.BASE_URI_DEV}/v1/internal/evaluation-events/${id}/download-sheet`,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${UserObj?.accessToken}`
        },
        // data: JSON.stringify({ rfqId: rfqId }),
        responseType: 'blob'
      })
        .then((res) => {
          if (res && res.data) {
            const url = window.URL.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'vendor_evaluation.xls');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
          } else {
            setAlertComponent({
              open: true,
              type: 'error',
              message: 'No Data Found',
            });
          }
        })
        .catch((error) => {
          setAlertComponent({
            open: true,
            type: 'error',
            message: `${error?.response?.data?.message}`,
          });
        })
        .finally(() => {
          setIsLoading(false);
          setIsDownloading(false);
        });
    } else {
      setAlertComponent({
        open: true,
        type: 'error',
        message: 'Please Select Rfq Number first',
      });
      setIsLoading(false);
    }
  }

  const calculateAverageRating = () => {
    const ratings = Object.values(reviewForm);
    if (ratings.length === 0) return 0;
    const total = ratings.reduce((sum, value) => sum + value, 0);
    return (total / ratings.length).toFixed(1);
  };
  const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + '...';
    }
    return text;
  };
  const clearFilters = () => {
    setSelectedProject('');
    setSelectedPackage('');
    setSelectedCategory('');
    setIsForMeChecked(false);
    getVendorEvaluationlist(requestPayload, filterText, isForMeChecked);
  };
  const vendorReallocationModal = () => {
    if (selectedVendorIDs.length === 0) {
      openAlert(true, "error", "Please select at least one vendor.");
      return;
    }
    setOpenRealloactionModal(true);
  }
  const averageRating = calculateAverageRating();
  return (
    <>
      <div className="login-forms">
        <div className="text-centers">
          <div className="search_filter_outerse ms-auto">
            <div className="search_mains">
              <h5>Vendor Performance Evaluation</h5>
            </div>
            <div className="evaluation_perfomance_rate_fgdreact">
              {/* <p className="department_rate">Deparment :</p>
              <p className="engineering_rate">Engineering</p> */}
              <div className="create_listing_project_div_bcfr">
                <p>My Vendor</p>
                <Switch
                  className="emp-ls-active-txt"
                  checked={isForMeChecked}
                  inputProps={{ "aria-label": "controlled" }}
                  onChange={(e) => handleForMeToggle(e.target.checked)}
                />
                <p>All Vendor</p>
              </div>
            </div>
          </div>
          <div className="search_filter_outers_admin ms-auto">
            <div className="admin_evaluation_block_auto_uters">
              <div className="search_main">
                <div id="custom-search-input">
                  <div className="input-group col-md-12">
                    <input
                      type="text"
                      className="form-control input-lg"
                      placeholder="Search here"
                      fdprocessedid="8achb"

                      onChange={onFilterTextChange}
                      value={filterText}
                      onKeyPress={onKeyPressHandler}
                    />
                    <span className="input-group-btn">
                      <button
                        className="btn btn-info btn-lg"
                        type="button"
                        fdprocessedid="trsp06"
                      >
                        <span className="glyphicon glyphicon-search">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-search"
                            viewBox="0 0 16 16"
                          >
                            <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0"></path>
                          </svg>
                        </span>
                      </button>
                    </span>
                  </div>
                </div>
              </div>
              <div className="select_perfomance_outer_react_project">
                <select
                  id="onboardingType"
                  class="form-select select_react_form_evaluation"
                  aria-label="Default select example"
                  onChange={handleProjectChange}
                  value={selectedProject}
                >
                  <option key="" value="">Project</option>
                  {vendorFilterData?.filterDropdowns?.projectNames.map((project, index) => (
                    <option key={index} value={project}>{project}</option>
                  ))}
                </select>
                <select
                  id="onboardingType"
                  class="form-select select_react_form_evaluation"
                  aria-label="Default select example"
                  onChange={handlePackageChange}
                  value={selectedPackage}
                >
                  <option key="" value="">Package</option>
                  {vendorFilterData?.filterDropdowns?.packageNames.map((pkg, index) => (
                    <option key={index} value={pkg}>{pkg}</option>
                  ))}
                </select>
                <select
                  id="onboardingType"
                  class="form-select select_react_form_evaluation"
                  aria-label="Default select example"
                  onChange={handleCategoryChange}
                  value={selectedCategory}
                >
                  <option key="" value="">Category</option>
                  {vendorFilterData?.filterDropdowns?.categories.map((category, index) => (
                    <option key={index} value={category}>{category}</option>
                  ))}
                </select>
                <Button variant="outlined" onClick={clearFilters}>Clear</Button>
              </div>
            </div>
            <div className="bpdt_po_order_react">
              <button
                className="create_btn_lr_creations"
                onClick={vendorReallocationModal}
              >
                Reallocation
              </button>
              <button class="btn btn-success btn_rating_respo" onClick={DownloadVendorReport} disabled={isDownloading}>
                <FileDownloadIcon />
                {isDownloading ? 'Downloading...' : 'Download in Excel'}</button>
              {/* <div className="filter_mains">
                <button fdprocessedid="byer54">
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="16"
                      fill="currentColor"
                      className="bi bi-funnel"
                      viewBox="0 0 16 16"
                    >
                      <path d="M1.5 1.5A.5.5 0 0 1 2 1h12a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.128.334L10 8.692V13.5a.5.5 0 0 1-.342.474l-3 1A.5.5 0 0 1 6 14.5V8.692L1.628 3.834A.5.5 0 0 1 1.5 3.5zm1 .5v1.308l4.372 4.858A.5.5 0 0 1 7 8.5v5.306l2-.666V8.5a.5.5 0 0 1 .128-.334L13.5 3.308V2z"></path>
                    </svg>
                  </span>
                  Filter
                </button>
              </div> */}
            </div>

          </div>
          <div className="tablecontainer_react_evaluation">
            <TableContainer className="mb-3 lets_customize_vendor_evaluationprofile" component={Paper}>
              <Table sx={{ minWidth: 700 }} aria-label="customized table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left">Vendor Name</StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block">Project</StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left">Package</StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left">Category Name</StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left">Engineering</StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left"></StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left">Bill Desk</StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left"></StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left">Store</StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left"></StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left">PMO</StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left"></StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left">Procurement</StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left"></StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left">EHS</StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left"></StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left">Projects</StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left"></StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left">Quality</StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left"></StyledTableCell>
                    <StyledTableCell className="table_react_listing_controlpanel_block" align="left">Average Rating</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {vendorEvaluationlist?.vendors.length < 1 && <>
                    <tr>
                      <td colSpan={10} className="text-center list-no-data">No Data Found</td>
                    </tr>
                  </>}
                  {vendorEvaluationlist?.vendors.length > 0 && <>
                    <StyledTableRow>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row"> <input type="checkbox" name="selectCheckbox" checked={isSelectAll}
                        onChange={handleSelectAll} /> </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row"> </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row">  </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row"> </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row">  Rating  </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row">  Remarks  </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row">  Rating  </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row">  Remarks  </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row">  Rating  </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row">  Remarks  </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row">  Rating  </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row">  Remarks  </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row">  Rating  </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row">  Remarks  </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row">  Rating  </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row">  Remarks  </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row">  Rating  </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row">  Remarks  </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row">  Rating  </StyledTableCell>
                      <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row">  Remarks  </StyledTableCell>

                    </StyledTableRow>
                    {vendorEvaluationlist?.vendors.map((row, rowIndex) => (
                      <>
                        <StyledTableRow key={row.project}>
                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">  <input type="checkbox" checked={selectedVendorIDs.includes(row._id)}
                            onChange={() => handleIndividualSelect(row)} style={{ marginRight: '5px' }} />
                            <Tooltip title={row.vendorName}>{(row.vendorName) ? truncateText(row.vendorName, 15) : ''}</Tooltip>
                          </StyledTableCell>

                          <StyledTableCell className="cell_tabel_controlpanel_listing_blockss" component="th" scope="row">
                            <p> <Tooltip title={row.projectName}>{(row.projectName) ? truncateText(row.projectName, 10) : ''}</Tooltip></p>
                          </StyledTableCell>

                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">
                            <p> <Tooltip title={row.packageName}>{(row.packageName) ? truncateText(row.packageName, 10) : ''}</Tooltip></p>
                          </StyledTableCell>

                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">
                            <p> <Tooltip title={row.category}>{(row.category) ? truncateText(row.category, 10) : ''}</Tooltip></p>
                          </StyledTableCell>
                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">
                            <div className="table_rating_evaluation_3_react" >
                              {row?.engineering?.workDone ? (
                                <span>
                                  {row?.engineering?.finalRating ? (
                                    <>
                                      {UserObj?.department?.departmentName !== 'ENGINEERING' ? (
                                        <button className="btn btn-success btn_rating_respo"
                                          disabled> Rated </button>
                                      ) : (
                                        <>
                                          <span onClick={() => { showFinalRating(row, 'engineering') }}> {row?.engineering?.finalRating}</span>
                                          <img src={starImages} alt="" style={{ paddingLeft: '5px' }} />
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    UserObj?.department?.departmentName !== 'ENGINEERING' ? (
                                      <button className="btn btn-success btn_rating_respo"
                                        disabled> Rated </button>
                                    ) : (
                                      <span onClick={() => { showFinalRating(row, 'engineering') }}> N/A</span>
                                    )
                                  )}
                                </span>
                              ) : (
                                UserObj?._id === row?.engineering?.assignee?._id ? (
                                  <button className="btn btn-success btn_rating_respo"
                                    onClick={() => { showRating(row) }}>
                                    Rating
                                  </button>
                                ) : (
                                  <button className="btn btn-success btn_rating_respo"
                                    disabled
                                    onClick={() => { showRating(row) }}>
                                    Rating
                                  </button>
                                )
                              )}
                            </div>
                          </StyledTableCell>

                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">
                            <div className="table_rating_evaluation_3_react">
                              <p> <Tooltip title={row?.engineering?.feedback}>{(row?.engineering?.feedback) ? truncateText(row?.engineering?.feedback, 10) : ''}</Tooltip></p>
                              <Tooltip title={row?.engineering?.assignee?.name}>
                                <img style={{ cursor: "pointer" }} src={evaluationImages} alt="" />
                              </Tooltip>
                            </div>
                          </StyledTableCell>

                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">
                            <div className="table_rating_evaluation_3_react">
                              {row?.billDesk?.workDone ? (
                                <span>
                                  {row?.billDesk?.finalRating ? (
                                    <>
                                      {UserObj?.department?.departmentName !== 'BILL_DESK' ? (
                                        <button className="btn btn-success btn_rating_respo"
                                          disabled> Rated </button>
                                      ) : (
                                        <>
                                          <span onClick={() => { showFinalRating(row, 'billDesk') }}>{row?.billDesk?.finalRating}</span>
                                          <img src={starImages} alt="" style={{ paddingLeft: '5px' }} />
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    UserObj?.department?.departmentName !== 'BILL_DESK' ? (
                                      <button className="btn btn-success btn_rating_respo"
                                        disabled> Rated </button>
                                    ) : (
                                      <span onClick={() => { showFinalRating(row, 'billDesk') }}> N/A</span>
                                    )
                                  )}
                                </span>

                              ) : (
                                UserObj?._id === row?.billDesk?.assignee?._id ? (
                                  <button className="btn btn-success btn_rating_respo"
                                    onClick={() => { showRating(row) }}>
                                    Rating
                                  </button>
                                ) : (
                                  <button className="btn btn-success btn_rating_respo"
                                    disabled
                                    onClick={() => { showRating(row) }}>
                                    Rating
                                  </button>
                                )
                              )}
                            </div>
                          </StyledTableCell>


                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">
                            <div className="table_rating_evaluation_3_react">
                              <p> <Tooltip title={row?.billDesk?.feedback}>{(row?.billDesk?.feedback) ? truncateText(row?.billDesk?.feedback, 10) : ''}</Tooltip></p>
                              <Tooltip title={row?.billDesk?.assignee?.name}>
                                <img style={{ cursor: "pointer", }} src={evaluationImages} alt="" />
                              </Tooltip>
                            </div>
                          </StyledTableCell>
                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">
                            <div className="table_rating_evaluation_3_react">
                              {row?.store?.workDone ? (
                                <span>
                                  {row?.store?.finalRating ? (
                                    <>
                                      {UserObj?.department?.departmentName !== 'STORE' ? (
                                        <button className="btn btn-success btn_rating_respo"
                                          disabled> Rated </button>
                                      ) : (
                                        <>
                                          <span onClick={() => { showFinalRating(row, 'store') }}> {row?.store?.finalRating}</span>
                                          <img src={starImages} alt="" style={{ paddingLeft: '5px' }} />
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    UserObj?.department?.departmentName !== 'STORE' ? (
                                      <button className="btn btn-success btn_rating_respo"
                                        disabled> Rated </button>
                                    ) : (
                                      <span onClick={() => { showFinalRating(row, 'store') }}> N/A</span>
                                    )
                                  )}
                                </span>
                              ) : (
                                UserObj?._id === row?.store?.assignee?._id ? (
                                  <button className="btn btn-success btn_rating_respo"
                                    onClick={() => { showRating(row) }}>
                                    Rating
                                  </button>
                                ) : (
                                  <button className="btn btn-success btn_rating_respo"
                                    disabled
                                    onClick={() => { showRating(row) }}>
                                    Rating
                                  </button>
                                )
                              )}
                              {/* <img src={starImages} alt="" /> */}
                            </div>
                          </StyledTableCell>
                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">
                            <div className="table_rating_evaluation_3_react">
                              <p> <Tooltip title={row?.store?.feedback}>{(row?.store?.feedback) ? truncateText(row?.store?.feedback, 10) : ''}</Tooltip></p>
                              <Tooltip title={row?.store?.assignee?.name}>
                                <img style={{ cursor: "pointer", }} src={evaluationImages} alt="" />
                              </Tooltip>
                            </div>
                          </StyledTableCell>

                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">
                            <div className="table_rating_evaluation_3_react">
                              {row?.pmo?.workDone ? (
                                <span>
                                  {row?.pmo?.finalRating ? (
                                    <>
                                      {UserObj?.department?.departmentName !== 'PMO' ? (
                                        <button className="btn btn-success btn_rating_respo"
                                          disabled> Rated </button>
                                      ) : (
                                        <>
                                          <span onClick={() => { showFinalRating(row, 'pmo') }}>{row?.pmo?.finalRating}</span>
                                          <img src={starImages} alt="" style={{ paddingLeft: '5px' }} />
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    UserObj?.department?.departmentName !== 'PMO' ? (
                                      <button className="btn btn-success btn_rating_respo"
                                        disabled> Rated </button>
                                    ) : (
                                      <span onClick={() => { showFinalRating(row, 'pmo') }}> N/A</span>
                                    )
                                  )}
                                </span>
                              ) : (
                                UserObj?._id === row?.pmo?.assignee?._id ? (
                                  <button className="btn btn-success btn_rating_respo"
                                    onClick={() => { showRating(row) }}>
                                    Rating
                                  </button>
                                ) : (
                                  <button className="btn btn-success btn_rating_respo"
                                    disabled
                                    onClick={() => { showRating(row) }}>
                                    Rating
                                  </button>
                                )
                              )}
                            </div>
                          </StyledTableCell>
                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">
                            <div className="table_rating_evaluation_3_react">
                              <p> <Tooltip title={row?.pmo?.feedback}>{(row?.pmo?.feedback) ? truncateText(row?.pmo?.feedback, 10) : ''}</Tooltip></p>
                              <Tooltip title={row?.pmo?.assignee?.name}>
                                <img style={{ cursor: "pointer", }} src={evaluationImages} alt="" />
                              </Tooltip>
                            </div>
                          </StyledTableCell>
                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">
                            <div className="table_rating_evaluation_3_react">
                              {row?.procurement?.workDone ? (

                                <span>
                                  {row?.procurement?.finalRating ? (
                                    <>
                                      {UserObj?.department?.departmentName !== 'PROCUREMENT' ? (
                                        <button className="btn btn-success btn_rating_respo"
                                          disabled> Rated </button>
                                      ) : (
                                        <>
                                          <span onClick={() => { showFinalRating(row, 'procurement') }}> {row?.procurement?.finalRating}</span>
                                          <img src={starImages} alt="" style={{ paddingLeft: '5px' }} />
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    UserObj?.department?.departmentName !== 'PROCUREMENT' ? (
                                      <button className="btn btn-success btn_rating_respo"
                                        disabled> Rated </button>
                                    ) : (
                                      <span onClick={() => { showFinalRating(row, 'procurement') }}> N/A</span>
                                    )
                                  )}
                                </span>
                              ) : (
                                UserObj?._id === row?.procurement?.assignee?._id ? (
                                  <button className="btn btn-success btn_rating_respo"
                                    onClick={() => { showRating(row) }}>
                                    Rating
                                  </button>
                                ) : (
                                  <button className="btn btn-success btn_rating_respo"
                                    disabled
                                    onClick={() => { showRating(row) }}>
                                    Rating
                                  </button>
                                )
                              )}
                              {/* <img src={starImages} alt="" /> */}
                            </div>
                          </StyledTableCell>
                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">
                            <div className="table_rating_evaluation_3_react">
                              <p> <Tooltip title={row?.procurement?.feedback}>{(row?.procurement?.feedback) ? truncateText(row?.procurement?.feedback, 10) : ''}</Tooltip></p>
                              <Tooltip title={row?.procurement?.assignee?.name}>
                                <img style={{ cursor: "pointer", }} src={evaluationImages} alt="" />
                              </Tooltip>
                            </div>
                          </StyledTableCell>
                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">
                            <div className="table_rating_evaluation_3_react">
                              {row?.ehs?.workDone ? (
                                <span>
                                  {row?.ehs?.finalRating ? (
                                    <>
                                      {UserObj?.department?.departmentName !== 'EHS' ? (
                                        <button className="btn btn-success btn_rating_respo"
                                          disabled> Rated </button>
                                      ) : (
                                        <>
                                          <span onClick={() => { showFinalRating(row, 'ehs') }}>   {row?.ehs?.finalRating}</span>
                                          <img src={starImages} alt="" style={{ paddingLeft: '5px' }} />
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    UserObj?.department?.departmentName !== 'EHS' ? (
                                      <button className="btn btn-success btn_rating_respo" disabled>
                                        Rated
                                      </button>
                                    ) : (
                                      <span onClick={() => { showFinalRating(row, 'ehs') }}> N/A</span>
                                    )
                                  )}
                                </span>

                              ) : (
                                UserObj?._id === row?.ehs?.assignee?._id ? (
                                  <button className="btn btn-success btn_rating_respo"
                                    onClick={() => { showRating(row) }}>
                                    Rating
                                  </button>
                                ) : (
                                  <button className="btn btn-success btn_rating_respo"
                                    disabled
                                    onClick={() => { showRating(row) }}>
                                    Rating
                                  </button>
                                )
                              )}

                              {/* <img src={starImages} alt="" /> */}
                            </div>
                          </StyledTableCell>
                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">
                            <div className="table_rating_evaluation_3_react">
                              <p> <Tooltip title={row?.ehs?.feedback}>{(row?.ehs?.feedback) ? truncateText(row?.ehs?.feedback, 10) : ''}</Tooltip></p>
                              <Tooltip title={row?.ehs?.assignee?.name}>
                                <img style={{ cursor: "pointer", }} src={evaluationImages} alt="" />
                              </Tooltip>
                            </div>
                          </StyledTableCell>
                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">
                            <div className="table_rating_evaluation_3_react">
                              {row?.projects?.workDone ? (
                                <span>
                                  {row?.projects?.finalRating ? (
                                    <>
                                      {UserObj?.department?.departmentName !== 'PROJECTS' ? (
                                        <button className="btn btn-success btn_rating_respo"
                                          disabled> Rated </button>
                                      ) : (
                                        <>
                                          <span onClick={() => { showFinalRating(row, 'projects') }}>  {row?.projects?.finalRating}</span>
                                          <img src={starImages} alt="" style={{ paddingLeft: '5px' }} />
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    UserObj?.department?.departmentName !== 'PROJECTS' ? (
                                      <button className="btn btn-success btn_rating_respo"
                                        disabled> Rated </button>
                                    ) : (
                                      <span onClick={() => { showFinalRating(row, 'projects') }}> N/A</span>
                                    )
                                  )}
                                </span>
                              ) : (
                                UserObj?._id === row?.projects?.assignee?._id ? (
                                  <button className="btn btn-success btn_rating_respo"
                                    onClick={() => { showRating(row) }}>
                                    Rating
                                  </button>
                                ) : (
                                  <button className="btn btn-success btn_rating_respo"
                                    disabled
                                    onClick={() => { showRating(row) }}>
                                    Rating
                                  </button>
                                )
                              )}
                              {/* <img src={starImages} alt="" /> */}
                            </div>
                          </StyledTableCell>
                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">
                            <div className="table_rating_evaluation_3_react">
                              <p> <Tooltip title={row?.projects?.feedback}>{(row?.projects?.feedback) ? truncateText(row?.projects?.feedback, 10) : ''}</Tooltip></p>

                              <Tooltip title={row?.projects?.assignee?.name}>
                                <img style={{ cursor: "pointer", }} src={evaluationImages} alt="" />
                              </Tooltip>
                            </div>
                          </StyledTableCell>
                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">
                            <div className="table_rating_evaluation_3_react">
                              {row?.quality?.workDone ? (
                                <span>
                                  {row?.quality?.finalRating ? (
                                    <>
                                      {UserObj?.department?.departmentName !== 'QUALITY' ? (
                                        <button className="btn btn-success btn_rating_respo"
                                          disabled> Rated </button>
                                      ) : (
                                        <>
                                          <span onClick={() => { showFinalRating(row, 'quality') }}>{row?.quality?.finalRating}</span>
                                          <img src={starImages} alt="" style={{ paddingLeft: '5px' }} />
                                        </>
                                      )}
                                    </>
                                  ) : (
                                    UserObj?.department?.departmentName !== 'QUALITY' ? (
                                      <button className="btn btn-success btn_rating_respo"
                                        disabled> Rated </button>
                                    ) : (
                                      <span onClick={() => { showFinalRating(row, 'quality') }}> N/A</span>
                                    )
                                  )}
                                </span>
                              ) : (
                                UserObj?._id === row?.quality?.assignee?._id ? (
                                  <button className="btn btn-success btn_rating_respo"
                                    onClick={() => { showRating(row) }}>
                                    Rating
                                  </button>
                                ) : (
                                  <button className="btn btn-success btn_rating_respo"
                                    disabled
                                    onClick={() => { showRating(row) }}>
                                    Rating
                                  </button>
                                )
                              )}

                              {/* <img src={starImages} alt="" /> */}
                            </div>
                          </StyledTableCell>
                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">
                            <div className="table_rating_evaluation_3_react">
                              <p> <Tooltip title={row?.quality?.feedback}>{(row?.quality?.feedback) ? truncateText(row?.quality?.feedback, 10) : ''}</Tooltip></p>

                              <Tooltip title={row?.quality?.assignee?.name}>
                                <img style={{ cursor: "pointer", }} src={evaluationImages} alt="" />
                              </Tooltip>
                            </div>
                          </StyledTableCell>
                          <StyledTableCell align="left" className="cell_tabel_controlpanel_listing_blockss">{row.averageRating}</StyledTableCell>
                        </StyledTableRow >
                      </>
                    ))}
                  </>
                  }
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          {vendorEvaluationlist?.vendors?.length > 0 && <>
            <div className="lets_pagination_package_listing_react">
              <div className="pagination_select_react_packagelr_detail">
                <select
                  className="form-select packagelrlisting from-hs"
                  onChange={onPageSizeChange}
                  value={requestPayload?.pageSize}
                >
                  <option value="10">10</option>
                  <option value="15">15</option>
                  <option value="20">20</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span className="react_text_showing">
                  {` Showing rows ${Number(vendorEvaluationlist?.pageSize) * Number(vendorEvaluationlist?.currentPage - 1) + 1
                    } to ${Number(vendorEvaluationlist?.pageSize) * Number(vendorEvaluationlist?.currentPage - 1) + Number(vendorEvaluationlist?.vendors.length)
                    } of ${vendorEvaluationlist?.totalItems} `}
                </span>
              </div>
              <Stack spacing={2}>
                <Pagination
                  count={vendorEvaluationlist?.totalPages}
                  page={vendorEvaluationlist?.currentPage}
                  onChange={onPaginationChange}
                  renderItem={(item) => (<>
                    <PaginationItem
                      className="pagination_react_listings"
                      slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                      {...item}
                    />
                  </>
                  )}
                />
              </Stack>
            </div>
          </>}




          {/* Reallocation Modal with Successful */}
          <Modal
            open={openrealloactionmodal}
            onClose={() => setOpenRealloactionModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">
                  Reallocation
                </h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenRealloactionModal(false)}
                ></button>
              </div>
              <div class="modal-body">
                <div className="select_finacial_year_evaluartion_sc">
                  <p className="vendor_evaluation_bvcy6_reacts1">Email</p>
                  <span className="required">*</span>
                </div>
                <div className="vendor_bcvevy_div_react">
                  <input
                    type="text"
                    class="form-control"
                    // placeholder="admin@gmail.com"
                    onChange={handleEmailChange}
                    value={email}
                  />
                </div>

                <div className="all_btn_modal_listing_evaluation">
                  <button
                    type="button"
                    class="btn clear_btn_status_block_lists"
                    onClick={() => setOpenRealloactionModal(false)}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    class="btn btn-success save_next_btns"
                    onClick={handleAllocationSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          <Modal
            open={openrealloactionsuccess}
            onClose={() => setOpenRealloactionSuccess(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenRealloactionSuccess(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={checkcircleImage} alt="" />
                <p>
                  The Vendor Reallocation successfully.
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    type="button"
                    class="btn btn-success save_next_btns"
                    onClick={() => {
                      setOpenRealloactionSuccess(false);
                    }}
                  >
                    Done
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Reallocation Modal with Successful */}

          {/* Vendor Performance Rating Evaluation */}
          <Modal
            open={openratingperfomanceevaluation}
            onClose={() => setOpenRatingPerfomancEvaluation(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={stylevendor} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">Vendor Evaluation Rating</h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenRatingPerfomancEvaluation(false)}
                ></button>
              </div>
              <div class="modal-body">
                <div>
                  <p className="provide_text_p">Please provide your ratings for the following criteria</p>
                </div>
                <div>
                  <div className="select_finacial_year_evaluartion_sc">
                    <p className="vendor_evaluation_bvcy6_reacts1">
                      Work Done
                    </p>
                    <span className="required">*</span>
                  </div>
                  <select id="venodr_workDone" class="form-select work_done_critera" aria-label="Default select example" fdprocessedid="lrpkn8" onChange={vendorTabChange}>
                    <option value="" >Please Select</option>
                    <option value="1">Yes</option>
                    <option value="2">NO</option>
                  </select>

                  {(perdomanceratingevaluation === 1 || perdomanceratingevaluation === "1") && (
                    <div className="steps_one_rating_vendor_evaluation">
                      {vendorRatingRole && departmentCriteria[vendorRatingRole] && (
                        <div>
                          {Object.keys(departmentCriteria[vendorRatingRole]).map(criteria => (
                            <div key={criteria}>
                              <p className="provide_text_capability" style={{ display: 'inline-flex' }}>{departmentCriteria[vendorRatingRole][criteria]}<div className="">
                                <Rating
                                  name={criteria}
                                  value={reviewForm[criteria] || 0}
                                  onChange={(event, newValue) => handleRatingChange(criteria, newValue)}
                                  max={5}
                                  style={{ paddingRight: '10px' }}
                                />
                              </div></p>

                              {/* <div className="approvel_btn_engineerning_capability">
                                <Box sx={{ "& > legend": { mt: 2 } }}>
                                  <Rating
                                    name={criteria}
                                    value={reviewForm[criteria] || 0}
                                    onChange={(event, newValue) => handleRatingChange(criteria, newValue)}
                                    max={5}
                                  />
                                </Box>
                                <div className="box_row_rating_vendor_fgrn">
                                  <p className="provide_text_drag">1-Poor</p>
                                  <p className="provide_text_drag">2-Below Average</p>
                                  <p className="provide_text_drag">3-Average</p>
                                  <p className="provide_text_drag">4-Good</p>
                                  <p className="provide_text_drag">5-Excellent</p>
                                </div>
                              </div> */}
                            </div>
                          ))}
                        </div>
                      )}


                      <div className="final_rating_average_fgrind">
                        <p className="provide_text_capability">Final Rating  <b style={{ fontsize: "20px" }}>{(averageRating) ? averageRating : ''}</b></p>
                        {/* <div className="vendorevaluationrating">
                          <h5></h5>
                          <Box sx={{ "& > legend": { mt: 2 }, }}  >
                            <Rating name="customized-10" value={Number(averageRating)} max={5} readOnly />
                          </Box>
                        </div> */}
                        <div className="select_finacial_year_evaluartion_sc">
                          <p className="vendor_evaluation_bvcy6_reacts1">
                            Feedback/Remarks
                          </p>
                          <span className="required">*</span>
                        </div>
                        <textarea value={feedback} class="form-control form-ha" onChange={(e) => setFeedback(e.target.value)} />
                      </div>
                    </div>
                  )}


                  {(perdomanceratingevaluation === 2 || perdomanceratingevaluation === "2") && (
                    <div className="steps2_rating_vendor_evaluation">
                      {vendorRatingRole && departmentCriteria[vendorRatingRole] && (
                        <div>
                          {Object.keys(departmentCriteria[vendorRatingRole]).map(criteria => (
                            <div key={criteria}>
                              <p className="provide_text_capability" style={{ display: 'inline-flex' }}>{departmentCriteria[vendorRatingRole][criteria]}
                                <div>
                                  <Rating
                                    name={criteria}
                                    value={reviewForm[criteria] || 0}
                                    onChange={(event, newValue) => handleRatingChange(criteria, newValue)}
                                    max={5}
                                    disabled
                                  />
                                </div>
                              </p>
                              {/* <div className="approvel_btn_engineerning_capability">
                                <Box sx={{ "& > legend": { mt: 2 } }}>
                                  <Rating
                                    name={criteria}
                                    value={reviewForm[criteria] || 0}
                                    onChange={(event, newValue) => handleRatingChange(criteria, newValue)}
                                    max={5}
                                    disabled
                                  />
                                </Box>
                                <div className="box_row_rating_vendor_fgrn">
                                  <p className="provide_text_drag">1-Poor</p>
                                  <p className="provide_text_drag">2-Below Average</p>
                                  <p className="provide_text_drag">3-Average</p>
                                  <p className="provide_text_drag">4-Good</p>
                                  <p className="provide_text_drag">5-Excellent</p>
                                </div>
                              </div> */}
                            </div>
                          ))}
                        </div>
                      )}
                      <div>

                        <div className="final_rating_average_fgrind">
                          <p className="provide_text_capability">Final Rating</p>
                          <div className="vendorevaluationrating">
                            <h5>N/A</h5>

                          </div>
                          <div className="select_finacial_year_evaluartion_sc">
                            <p className="vendor_evaluation_bvcy6_reacts1">
                              Feedback/Remarks
                            </p>
                            <span className="required">*</span>
                          </div>
                          <textarea type="textarea" class="form-control form-ha" fdprocessedid="ik9bhc" onChange={(e) => setFeedback(e.target.value)} />
                        </div>
                      </div>
                    </div>)}
                </div>


                <div className="all_btn_modal_listing_evaluation">
                  <button
                    type="button"
                    class="btn btn-danger"
                    onClick={() => setOpenRatingPerfomancEvaluation(false)}
                  >
                    Discard
                  </button>
                  <button
                    type="button"
                    class="btn btn-success save_next_btns"
                    // onClick={() => {
                    //   setOpenRatingPerfomancEvaluation(false);
                    //   setOpenRatingPerfomancSuccess(true);
                    // }}
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          <Modal
            open={openratingperfomancesuccess}
            onClose={() => setOpenRatingPerfomancSuccess(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style1} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel"></h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenRatingPerfomancSuccess(false)}
                ></button>
              </div>
              <div class="modal-bodys">
                <img src={checkcircleImage} alt="" />
                <p>
                  Rating Submission Successful
                  <br /> Thank you for your evaluation.
                </p>
                <div className="all_btn_modal_listing">
                  <button
                    type="button"
                    class="btn btn-success save_next_btns"
                    onClick={() => {
                      setOpenRatingPerfomancSuccess(false);
                    }}
                  >
                    Done
                  </button>
                </div>
              </div>
            </Box>
          </Modal>
          {/* Vendor Performance Rating Evaluation */}

          {/* Vendor Final Rating to show the Modal  */}
          <Modal
            open={openfinalratingmodal}
            onClose={() => setOpenFinalRatingModal(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={stylevendor} className="modal_react_controlpanel_employees">
              <div className="modal-header">
                <h1 className="modal-title fs-5" id="exampleModalLabel">Vendor Evaluation Final Rating</h1>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="kum8iho"
                  onClick={() => setOpenFinalRatingModal(false)}
                ></button>
              </div>
              <div class="modal-body">
                <div>
                  {departmentCriteria[vendorFinalRatingDepartKey] && (
                    <>
                      <div className="steps_one_rating_vendor_evaluation">

                        <div>
                          <div className="select_finacial_year_evaluartion_sc">
                            <p className="vendor_evaluation_bvcy6_reacts1">
                              Work Done
                            </p>
                            <span className="required">*</span>
                          </div>
                          <select id="onboardingType" class="form-select work_done_critera" aria-label="Default select example" fdprocessedid="lrpkn8" onChange={vendorTabChange} disabled value={vendorFinalRating[vendorFinalRatingDepartKey].workDone === 'Yes' ? '1' : '2'}>
                            <option value="1" >Yes</option>
                            <option value="2">NO</option>
                          </select>
                          {Object.keys(departmentCriteria[vendorFinalRatingDepartKey]).map((criteria, index) => (
                            <>
                              <p className="provide_text_capability">{departmentCriteria[vendorFinalRatingDepartKey][criteria]}</p>
                              <div className="approvel_btn_engineerning_capability">
                                <Box sx={{ "& > legend": { mt: 2 }, }}  >
                                  {vendorFinalRating[vendorFinalRatingDepartKey].workDone === 'Yes' ?
                                    (<Rating name="customized-10" key={`customized-10-${criteria}`}
                                      defaultValue={(vendorFinalRating[vendorFinalRatingDepartKey].reviewForm[criteria]) ? vendorFinalRating[vendorFinalRatingDepartKey].reviewForm[criteria] : ''}
                                      max={5}
                                      disabled
                                    />) :
                                    (<Rating
                                      name={criteria}
                                      value={reviewForm[criteria] || 0}
                                      onChange={(event, newValue) => handleRatingChange(criteria, newValue)}
                                      max={5}
                                      disabled
                                    />)
                                  }
                                </Box>
                                <div className="box_row_rating_vendor_fgrn">
                                  <p className="provide_text_drag">1-Poor</p>
                                  <p className="provide_text_drag">2-Below Average</p>
                                  <p className="provide_text_drag">3-Average</p>
                                  <p className="provide_text_drag">4-Good</p>
                                  <p className="provide_text_drag">5-Excellent</p>
                                </div>
                              </div>
                            </>
                          ))}
                        </div>

                      </div>
                      <div className="final_rating_average_fgrind">
                        <p className="provide_text_capability">Final Rating   <b>{vendorFinalRating[vendorFinalRatingDepartKey].workDone === 'Yes' ? vendorFinalRating[vendorFinalRatingDepartKey].finalRating : 'N/A'}</b></p>


                        {/* <div className="vendorevaluationrating"> 
                      <Box sx={{ "& > legend": { mt: 2 }, }}  >
                        <Rating name="customized-10" defaultValue={4} max={5} />
                      </Box>
                    </div> */}
                        <div className="select_finacial_year_evaluartion_sc">
                          <p className="vendor_evaluation_bvcy6_reacts1">
                            Feedback/Remarks
                          </p>
                          <span className="required">*</span>
                        </div>
                        <textarea disabled value={vendorFinalRating[vendorFinalRatingDepartKey].feedback} class="form-control form-ha" onChange={(e) => setFeedback(e.target.value)} />
                      </div>
                    </>
                  )}
                </div>


                <div className="all_btn_modal_listing_evaluation">
                  <button
                    type="button"
                    class="btn btn-danger"
                    onClick={() => setOpenFinalRatingModal(false)}
                  >
                    Close
                  </button>

                </div>
              </div>
            </Box>
          </Modal>

          {/* Vendor Final Rating to show the Modal  */}
          <AlertComponent
            alertComponent={alertComponent}
            handleClose={handleClose}
          />
          <Backdrop
            sx={{
              color: "#fff",
              zIndex: (theme) => theme.zIndex.drawer + 1,
            }}
            open={isLoading}
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        </div>
      </div >
    </>
  );
}

export default EvaluationPerfomonaceRatting;
